import PortfolioManualTradeDetailCard from './PortfolioManualTradeDetailCard';

export default PortfolioManualTradeDetailCard;
